import { render } from "./StatoCard.vue?vue&type=template&id=e510ab5c&ts=true"
import script from "./StatoCard.vue?vue&type=script&lang=ts"
export * from "./StatoCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__